import { useState, useMemo } from 'react'
import { useApplicationSettings } from 'hooks/usePageConfig'
import { InsightContentSettingType } from 'components/insightContent/types'
import CountType from 'enums/CountType'
import {
  convertToInsightContentSetting,
  addSelectionFilterToWidgetSetting
} from '../InsightModal/utils'
import { SideBySideWidgetsType, InsightObjective, SideBySideSelectionType } from '../../types'
import useDecoratedSearchFilterComposingStrategy from './useSearchFilterComposingStrategy'
import useDecoratedWidgetSettingComposingStrategy from './useWidgetSettingComposingStrategy'

const useSelectedInsights = (widgetSetting: SideBySideWidgetsType) => {
  const countType = widgetSetting.countType || CountType.MENTIONS
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [selection, setSelection] = useState<InsightObjective[]>([])
  const searchFilterComposingStrategy = useDecoratedSearchFilterComposingStrategy(widgetSetting)
  const widgetSettingComposingStrategy = useDecoratedWidgetSettingComposingStrategy(widgetSetting)
  const applicationSettings = useApplicationSettings()

  const detailSetting = useMemo<InsightContentSettingType | undefined>(() => {
    if (isModalOpen && selection.length > 0) {
      return convertToInsightContentSetting(widgetSetting, searchFilterComposingStrategy, selection)
    }
    return undefined
  }, [isModalOpen, widgetSetting, searchFilterComposingStrategy, selection])

  const widgetSettingWithSelection = useMemo<any>(() => {
    if (isModalOpen && selection.length > 0) {
      return addSelectionFilterToWidgetSetting(
        widgetSetting,
        applicationSettings,
        widgetSettingComposingStrategy,
        selection
      )
    }
    return undefined
  }, [isModalOpen, widgetSetting, applicationSettings, widgetSettingComposingStrategy, selection])

  const handleClick = (target: SideBySideSelectionType) => {
    if (target.value <= 0) {
      return
    }

    setSelection([
      {
        ...target
      }
    ])
    setIsModalOpen(true)
  }

  return {
    isModalOpen,
    setIsModalOpen,
    selection,
    countType,
    detailSetting,
    handleClick,
    widgetSettingWithSelection
  }
}

export default useSelectedInsights
